'use memo';

import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { useCallback, useMemo } from 'react';
import NSWAgreementSignatureStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/NSW/NSWAgreementSignatureStageSteps';
import { TaskModalPageProps } from '../TaskModalPageProps';

const NswAgreementCommissionPage = ({ task, toggleTaskStep }: TaskModalPageProps) => {
  const taskSteps = useMemo(() => task.taskSteps ?? [], [task.taskSteps]);

  const updateTaskStep = useCallback(
    (step: { order?: number }, isChecked: boolean) => {
      toggleTaskStep(step.order ?? 0, isChecked);
    },
    [toggleTaskStep]
  );

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography size="large" type="label" id="step3title" color="var(--text-primary)">
        Step 3: Confirm Signatures
      </AgxTypography>
      <NSWAgreementSignatureStageSteps tasksStage={taskSteps} updateTaskStep={updateTaskStep} />
    </AgxSpacer>
  );
};

export default NswAgreementCommissionPage;
